import { useMutation } from '@tanstack/react-query';
import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';
import { apiClient } from '@/_config/lib/axios/api-client';
import type { PlaceFareDataParams } from './post-place-fare';

interface PutUpdatePlaceFareParams {
  placeId: string;
  fareData: PlaceFareDataParams;
}

const putUpdatePlaceFare = async ({
  placeId,
  fareData,
}: PutUpdatePlaceFareParams) =>
  apiClient
    .put(`/estabelecimentos/${placeId}/fare/update-fare`, fareData)
    .then(response =>
      handleResponseSuccess(
        response,
        'Tarifa do estabelecimento atualizada com sucesso!',
      )(),
    )
    .catch(
      handleResponseThrowError(
        'Não foi possível atualizar a tarifa do estabelecimento.',
      ),
    );

export const useUpdatePlaceFare = () => {
  return useMutation({
    mutationFn: putUpdatePlaceFare,
  });
};
